<template>
  <div class="container">
      <div class="topView" v-if="details">
           <div class="topView_top">
                <div class="topView_top_left">
                    <div class="topView_top_left_top">
                        <img class="topView_top_left_top_img" src="../../assets/images/icon_approve_visitor.png"/>
                        <span class="topView_top_left_top_span">访客预约</span>
                    </div>
                    <span class="topView_top_left_bottom">{{details.createTime |formatTime}}</span>
                </div>
                <img v-if="examineStatus==2" class="topView_top_Right" src="../../assets/images/icon_audit_passed.png"/>
                <img v-if="examineStatus==3" class="topView_top_Right" src="../../assets/images/icon_audit_failed.png"/>

           </div>

           <div class="topView_item">
               <span class="topView_item_left">申请人</span>
               <span class="topView_item_right">{{details.visitorUserName}}</span>
           </div>
            <div class="topView_item">
               <span class="topView_item_left">手机号</span>
               <!-- <span class="topView_item_right blue">{{details.phone}}</span> -->
               <a class="topView_item_right blue" :href="'tel:'+details.visitorMobile" :phone="details.visitorMobile">{{details.visitorMobile}}</a>
           </div>
           <div class="topView_item" v-if='visitorIdType'>
               <span class="topView_item_left">证件类型</span>
               <span class="topView_item_right">{{visitorIdType||'暂无'}}</span>
           </div>

           <div class="topView_item" v-if='visitorId'>
               <span class="topView_item_left">证件号码</span>
               <span class="topView_item_right">{{visitorId||'暂无'}}</span>
           </div>
            <div class="topView_item" v-for="item in tbVisitorRegs" :key="item.regKey" v-if="item.regKey == 'visitor_is_fever' || item.regKey == 'visitor_is_mask' || item.regKey == 'visitor_arrive_wh'">
                <span class="topView_item_left">{{item.regDicName}}</span>
                <span class="topView_item_right">{{item.regDicValue}}</span>
            </div>
           <div class="topView_line"></div>

           <div class="topView_item">
               <span class="topView_item_left">拜访日期</span>
               <span class="topView_item_right">{{details.visitorDate}}</span>
           </div>
           <div class="topView_item" v-if="details.visitorType">
               <span class="topView_item_left">拜访事由</span>
               <span class="topView_item_right">{{details.visitorType}}</span>
           </div>
           <!-- <div class="topView_item">
               <span class="topView_item_left">部门</span>
               <span class="topView_item_right">15801829819</span>
           </div> -->

      </div>

      <div class="shenpi_person" v-if="examineStatus!=1 && approvalUser">
            <span class="topView_item_left">审批人</span>
            <span class="topView_item_right">{{approvalUser}}</span>
      </div>


      <div class="foot" v-if="examineStatus==1">
          <span class="footSpan">{{details.userName}}申请拜访贵公司，请核实信息并尽快处理，警惕错误操作有可能为您的公司带来风险</span>
          <div class="footdiv button">
              <span class="foot_button_1 btn_primary" @click="updateVisitorStatus(3)">拒绝</span>
              <span class="foot_button_2 btn_default" @click="updateVisitorStatus(2)" >通过</span>
          </div>
      </div>

 </div>
 </template>
<script>
import { mapState } from 'vuex';
import { getVisitorDetailById,updateVisitorStatus } from "../../utils/api";
import util from '../../utils/util';

export default {
  name: "approvalDetail",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },

  filters: {
    formatTime(val){
      return util.formatTime(new Date(val),10)
    }
  },
  data() {
    return {
        id:'',
        pageNo:1,
        status:'',
        approvalUser:'',
        details:'',
        tbVisitorRegs:[],
        examineStatus:"",
        visitorIdType:'',
        visitorId:'',
    }
  },

  created() {
      let query = this.$route.params;
      this.id = query.id
      this.getVisitorDetailByIdAction()
  },
  activated () {
    //this.getParkInfo();
    // if (this.parkId !== this.$route.params.id) {
    //   this.parkId = this.$route.params.id;
    //   this.getParkMemberAction();
    // }
  },
  methods: {
      getVisitorDetailByIdAction(){
        getVisitorDetailById({
          "visitorId": this.id
         }).then(res => {
          console.log(res)
          if (res.res.code == 10000) {
            this.details = res.body.visitorOutput
            this.tbVisitorRegs = res.body.tbVisitorRegs
            this.visitorIdType = res.body.visitorOutput.visitorIdType
            this.visitorId = res.body.visitorOutput.visitorId
            this.examineStatus = res.body.visitorOutput.examineStatus,
            this.approvalUser = res.body.visitorOutput.examineUserName
          }else{
           // toast.showErrorMessage(res.res.msg);
          }
        })

      },

       updateVisitorStatus: function(status) {
           util.showLoading()
        updateVisitorStatus({
          visitorId: this.id,
          status: status,
          marketId:  this.common.marketInfo.id,
        }).then(res => {
            util.hideLoading()
          if (res.res.code === 10000) {
            this.examineStatus =status;
            this.details.examineStatus = status
            // if(this.common.userInfo.name){
            //     this.approvalUser = this.common.userInfo.name
            // }else{
                this.approvalUser = this.common.userTenantInfo.userName || this.common.userInfo.userName
            // }
          }else{
              util.showToast(res.res.msg)
          }
        })
      }

  },
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EEEEEE;
  .flex(column);
}

.topView{
    flex-direction: column;
    margin-top: 28px;
    margin-left: 20px;
    width: 710px;
    background-color: #ffffff;
    border-radius:8px;
    padding-bottom: 20px;
}

.topView_top{
    width: 710px;
    height: 120px;
    margin-top: 28px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

}

.topView_top_left{
     display: flex;
     margin-top: 12px;
     flex-direction:column;
     margin-left: 40px;
     width: 96px;
     width: 500px;
    //  display: flex;
}

.topView_top_Right{
    width: 120px;
    height: 120px;
    display: flex;
    margin-right: 28px;
}

.topView_top_left_top{
    flex-direction:row;
    width: 500px;
    display: flex;
}
.topView_top_left_top_img{
    width:44px ;
    height: 44px;
    display: flex;
}
.topView_top_left_top_span{
    margin-left: 20px;
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
}
.topView_top_left_bottom{
    display: flex;
    margin-top: 20px;
    height:34px;
    font-size:24px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:34px;

}

.topView_item{
    width: 710px;
    height: 78px;
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.topView_item_left{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;

}

.topView_item_right{
    margin-right: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.blue{
    color:#1740DA
}
.topView_line{
   margin-top: 5px;
   margin-bottom: 5px;
   margin-left: 40px;
   width:630px;
   height:2px;
   background-color:rgba(234,234,234,1);
}

.shenpi_person{
    margin-left: 20px;
    margin-top: 20px;
    background-color: #ffffff;
    width: 710px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius:8px;
}

.foot{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
    width: 100%;
    height: 224px;
    display: flex;
    background-color: white;
    flex-direction: column;
}

.footSpan{
    margin-top: 28px;
    margin-left: 40px;
    width:670px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:34px;
}

.footdiv{
    margin-top: 40px;
    width:100%;
    flex-direction: row;
    display: flex;
    justify-content: space-between;

}
.foot_button_1{
    // display: flex;
    margin-left: 32px;
    width:332px;
    height:68px;
    border-radius:4px;
    border:2px solid rgba(23,64,218,1);
    font-size:28px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:68px;
    text-align: center;

}
.foot_button_2{
    // display: flex;
    margin-right: 32px;
    width:332px;
    height:68px;
    border-radius:4px;
    background-color: #1740DA;
    .border(rgba(23,64,218,1));
    font-size:28px;
    font-weight:400;
    color:#ffffff;
    line-height:68px;
    text-align: center;

}

</style>